import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PROFILE = "https://instagram.com/seed.imoveis";

export const InstagramMural = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/instagram-posts`).then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  if (posts === null) return null;

  return (
    <section className="bg-seed-deep py-24 text-seed-off md:py-32" data-testid="instagram-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 flex flex-col gap-8 md:flex-row md:items-end md:justify-between"
        >
          <div className="max-w-xl">
            <p className="mb-4 text-sm font-bold uppercase tracking-[0.25em] text-seed-vivid">Instagram</p>
            <h2 className="font-heading text-4xl font-black tracking-tighter sm:text-5xl" data-testid="instagram-title">
              Acompanhe a Seed de perto.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-seed-off/60">
              Novos imóveis, bastidores e conquistas — direto no nosso perfil.
            </p>
          </div>
          <a
            href={PROFILE}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-cta"
            className="inline-flex w-fit items-center gap-3 rounded-full bg-seed-vivid px-8 py-4 font-heading text-sm font-bold text-seed-deep transition-transform duration-300 hover:scale-105"
          >
            <Instagram size={18} strokeWidth={2.5} /> Seguir @seed.imoveis
          </a>
        </motion.div>

        {posts.length > 0 && (
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6" data-testid="instagram-grid">
            {posts.map((p, i) => (
              <motion.a
                key={p.id}
                href={p.link || PROFILE}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="group relative block overflow-hidden rounded-lg"
                data-testid={`instagram-post-${p.id.slice(0, 8)}`}
              >
                <img
                  src={p.image}
                  alt={p.caption || "Post do Instagram"}
                  loading="lazy"
                  className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-end bg-seed-deep/0 p-3 transition-colors duration-300 group-hover:bg-seed-deep/60">
                  {p.caption && (
                    <p className="line-clamp-2 text-xs font-semibold text-seed-off opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      {p.caption}
                    </p>
                  )}
                </div>
              </motion.a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
